<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13 15V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V15H13ZM3 13C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3ZM19 2C19.5523 2 20 2.44772 20 3C20 3.55228 19.5523 4 19 4H13V9H11V4H5C4.44772 4 4 3.55228 4 3C4 2.44772 4.44772 2 5 2H19Z"
    fill="currentColor"
  />
</svg>
